import React from 'react';
import { LockClosedIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

const Login: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Login</h1>
      <p className="section-description">
        Access the dashboard by logging in with your credentials. The login page
        provides a secure way to authenticate and access the system.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Login Information
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <EnvelopeIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Current URL</h3>
              <p className="feature-description">
                https://uptialogic.com/admin/login
              </p>
            </div>
          </div>

          <div className="feature-item">
            <EnvelopeIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Future URL</h3>
              <p className="feature-description">
                https://admin.uptialogic.com/login
              </p>
            </div>
          </div>

          <div className="feature-item">
            <LockClosedIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Credentials</h3>
              <p className="feature-description">
                Email: admin@admin.com
                <br />
                Password: password
              </p>
              <small>This is the default credentials for the admin account. Please change it after logging in.</small>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <ul className="list-disc list-inside space-y-2 text-gray-600">
          <li>Secure login form with email and password fields</li>
          <li>"Remember Me" checkbox for persistent sessions</li>
          <li>Password reset functionality</li>
          <li>Responsive design for all devices</li>
        </ul>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Security Notes
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Always use a strong, unique password</li>
            <li>Enable two-factor authentication if available</li>
            <li>Never share your login credentials</li>
            <li>Log out when using public computers</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Login; 